import React from 'react';
import { Search } from 'lucide-react';

const SearchBar = ({ searchQuery, onSearchChange }) => {
  return (
    <div className="relative max-w-md w-full" data-testid="search-bar">
      <Search className="absolute left-4 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-600" />
      <input
        type="text"
        value={searchQuery}
        onChange={(e) => onSearchChange(e.target.value)}
        placeholder="Search releases..."
        data-testid="search-input"
        className="w-full pl-12 pr-4 py-3 bg-white border border-gray-300 rounded-full text-black placeholder-gray-500 font-secondary focus:outline-none focus:border-black transition-all"
      />
    </div>
  );
};

export default SearchBar;
